import { NavigationHeader } from "@/components/NavigationHeader/NavigationHeader";
import { usePageTheme } from "@/hooks/usePageTheme";
import { BACKGROUND_BY_THEME } from "@/utils/pageThemeStyles";
import { VStack } from "@leplein/ui";
import { PropsWithChildren } from "react";

interface MainLayoutProps extends PropsWithChildren {}

export const MainLayout = ({ children }: MainLayoutProps) => {
	const theme = usePageTheme();

	return (
		<VStack className={`min-h-screen ${BACKGROUND_BY_THEME[theme]}`}>
			<NavigationHeader />
			<main className="z-0 flex flex-col flex-1">{children}</main>
		</VStack>
	);
};
